const env = {
  ID: 'dev',
  API_URL: 'https://a3s8rlzru5.execute-api.ap-southeast-1.amazonaws.com/prod',
  API_URL_ACCOUNTING: 'https://rxel3qpid1.execute-api.ap-southeast-1.amazonaws.com/prod'
};

export default env;
